import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
// import 'font-awesome/css/font-awesome.css'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#87CEEB",
        secondary: "#0D47A1",
        info: "#0277BD",
        error: "#FF4081",
        warning: "#FFC260",
        success: "#3CD4A0",
        lightgrey: "#EEEEEE",
        textColor: "#B9B9B9",
        iconColor: "#FFFF59",
        grayBold: "#4a4a4a",
        positive: '#2196F3',
        negative: '#EF5350',
        apex0: "#008ffb",
        apex1: "#00e396",
        apex2: "#feb019",
        apex3: "#ff4560",
        apex4: "#775dd0",
      },
    },
  },
});
